export default class LuSession {
  constructor(objIn = {}) {
    const defaults = {
      //Id is required
      Id: 0,
      //Year is required
      Year: 0,
      //Title is required
      Title: '',
      //IsActive is required
      IsActive: true,
      //SessionStartDate is required
      SessionStartDate: new Date().toISOString().split('T')[0],
      //SessionEndDate is required
      SessionEndDate: new Date().toISOString().split('T')[0],
      //SpecialSessionValue is required
      SpecialSessionValue: 0,
      //HasSessionLandingPage is required
      HasSessionLandingPage: false,
      LsoRefreshDate: null,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.Id = obj.Id
    this.Year = obj.Year
    this.Title = obj.Title
    this.IsActive = obj.IsActive
    this.SessionStartDate = obj.SessionStartDate
    this.SessionEndDate = obj.SessionEndDate
    this.SpecialSessionValue = obj.SpecialSessionValue
    this.HasSessionLandingPage = obj.HasSessionLandingPage
    this.LsoRefreshDate = obj.LsoRefreshDate
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    return obj
  }
}
